import Link from "next/link";
import { Stack } from "@mui/material";

import { SSText } from "src/components/base/components/SSText";

import { routes } from "src/shared/routes";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "St. Louis Cardinals Upgrades",
    description:
      "Items must be picked up at Theme Ticket distribution within 45 min of scheduled first pitch. Please select the correct size for items. Size exchanges will not be available at distribution. All sales final. No refunds or exchanges.",
    authRedirectPage: routes.home,
    buttonLabel: "View Upgrades",
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question:
      "How come I don't see theme merch upgrades available for purchase?",
    answer:
      "Theme night upgrades are only eligible for those with a game ticket already. If you do not have a ticket for the game, please go to Cardinals Ticket Information | St. Louis Cardinals to purchase.",
  },
  {
    question: "Will there be theme night upgrades available for every game?",
    answer:
      "Theme night upgrades are subject to availability, please check back in on the day of the game to see eligible offers.",
  },
  {
    question: "Where is my theme night upgrade barcode?",
    answer:
      "After successful purchase, theme night upgrades will be delivered within your Ballpark app. Please note that these tickets are not eligible for entry.",
  },
  {
    question: "Can these theme night upgrades be transferred to a friend?",
    answer:
      "Theme night upgrades are non transferrable and not eligible for resale.",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    In connection with your reservation, you will receive ticket-related
    commercial emails from https://www.mlb.com/cardinals. You may unsubscribe at
    any time. By checking this box you agree to receive additional commercial
    emails from https://www.mlb.com/cardinals and MLB.com. The terms and
    conditions of your ticket and policies applicable to its use are available
    online at https://www.mlb.com/cardinals/tickets/terms-and-conditions. By
    clicking the Purchase Tickets button, you agree to accept all Terms and
    Conditions. Your purchase is not complete until a St. Louis Cardinals
    representative connects with you to complete your purchase. Upon completing
    your purchase, you acknowledge and agree that your credit card will be
    charged. By clicking &apos;Purchase Tickets&apos;, you agree to the{" "}
    <Link href="https://www.mlb.com/app/ballpark/official-information/privacy-policy">
      MLB Privacy Policy
    </Link>
    ,{" "}
    <Link href="https://www.mlb.com/app/ballpark/official-information/terms-of-use">
      Terms of Use
    </Link>{" "}
    and to receive your ticket(s) via an SMS text message to the mobile #
    associated with your St. Louis Cardinals account. Message and data rates may
    apply. Tickets will be made available in the MLB Ballpark mobile application
    only. MLB.com and supported mobile device required.
  </>
);

export const NavSubmenuLinks = () => {
  const theme = useSSTheme();

  const links = [
    {
      id: 2,
      label: "MLB Privacy Policy",
      onClick: () => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
          "_self"
        );
      },
    },
    {
      id: 3,
      label: "MLB Terms of Use",
      onClick: () => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
          "_self"
        );
      },
    },
  ];

  return (
    <>
      {links.map((link) => {
        return (
          <Stack
            key={link.id}
            spacing={2}
            direction={"row"}
            alignItems={"center"}
            onClick={() => link.onClick()}
            p={1}
            sx={{
              cursor: "pointer",
              pointerEvents: "auto",
              borderRadius: 2,
              "& .MuiSvgIcon-root": {
                color: theme.colors.gray[200],
              },
              "&:hover": {
                backgroundColor: theme.colors.gray[100],
              },
            }}
          >
            <SSText color={theme.colors.gray[300]}>{link.label}</SSText>
          </Stack>
        );
      })}
    </>
  );
};

export const FooterLinks = () => {
  const theme = useSSTheme();
  return (
    <>
      <SSText
        variant="body"
        onClick={() => {
          window.open(
            "https://www.mlb.com/app/ballpark/official-information/privacy-policy"
          );
        }}
        sx={{
          cursor: "pointer",
          color: theme.colors.common.white,
          textDecoration: "underline",
          textUnderlineOffset: "4px",
        }}
      >
        MLB Privacy Policy
      </SSText>
      <SSText
        variant="body"
        onClick={() => {
          window.open(
            "https://www.mlb.com/app/ballpark/official-information/terms-of-use"
          );
        }}
        sx={{
          cursor: "pointer",
          color: theme.colors.common.white,
          textDecoration: "underline",
          textUnderlineOffset: "4px",
        }}
      >
        MLB Terms of Use
      </SSText>
    </>
  );
};
